import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

/**
 * 导出PDF
 * @param title 导出后的文件名
 * @param ele 要导出的dom节点
 */
export const exportPDF = async (title: string, ele: HTMLElement, isPicture?: boolean) => {
  // 根据dpi放大
  const scale = window.devicePixelRatio > 1 ? window.devicePixelRatio : 2;
  // const width = ele.offsetWidth;
  // const height = ele.offsetHeight;

  // const canvas = document.createElement('canvas');
  // canvas.width = width * scale;
  // canvas.height = height * scale;
  // const contentWidth = canvas.width;
  // const contentHeight = canvas.height;

  // 一页pdf显示html页面生成的canvas高度;
  // const pageHeight = (contentWidth / 592.28) * 841.89;
  // html页面高度
  // let leftHeight = contentHeight;

  // 页面偏移
  // let position = 0;

  // a4纸的尺寸[595.28, 841.89]，html页面生成的canvas在pdf中图片的宽高
  // const imgWidth = 595.28;
  // const imgHeight = (592.28 / contentWidth) * contentHeight;

  // 图片处理
  const pdfCanvas = await html2canvas(ele, {
    allowTaint: true,
    useCORS: true,
    // canvas,
    scale,
    // width,
    // height,
    x: 0,
    y: 0,
  });
  const imgDataUrl = pdfCanvas.toDataURL();
  if (isPicture) {
    const link = document.createElement('a');
    link.href = imgDataUrl;
    link.setAttribute('download', title);
    link.click();
    return;
  }
  const contentWidth = pdfCanvas.width;
  const contentHeight = pdfCanvas.height;

  const pdfWidth = ((contentWidth + 10) / 2) * 0.75;
  const pdfHeight = ((contentHeight + 200) / 2) * 0.75;
  const imgWidth = pdfWidth;
  const imgHeight = (contentHeight / 2) * 0.75;

  // if (height > 14400) {
  //   // 超出jspdf高度限制时
  //   const ratio = 14400 / height;
  //   // height = 14400;
  //   width *= ratio;
  // }

  /* eslint-disable */
  const pdf = new jsPDF(pdfWidth > pdfHeight ? 'landscape' : 'portrait', 'pt', [
    pdfWidth,
    pdfHeight,
  ]);

  pdf.addImage(imgDataUrl, 'png', 0, 0, imgWidth, imgHeight);

  // 缩放为 a4 大小  pdfpdf.internal.pageSize 获取当前pdf设定的宽高
  // height = (height * pdf.internal.pageSize.getWidth()) / width;
  // width = pdf.internal.pageSize.getWidth();

  // if (leftHeight < pageHeight) {
  //   pdf.addImage(imgDataUrl, 'png', 0, 0, imgWidth, imgHeight);
  // } else {
  //   // 分页
  //   while (leftHeight > 0) {
  //     pdf.addImage(imgDataUrl, 'png', 0, position, imgWidth, imgHeight);
  //     leftHeight -= pageHeight;
  //     position -= 841.89;
  //     // 避免添加空白页
  //     if (leftHeight > 0) {
  //       pdf.addPage();
  //     }
  //   }
  // }

  // 导出下载
  await pdf.save(`${title}.pdf`);
  return;
};
